function createDiscoverCarouselCards() {
    const arr = discoverPerformanceData;
    const cards = arr.map(
        (item, index) =>
            `<div class="discover-slider__slide ${index === 0 && 'active'}">
                        <div
                            class="pos-relative w-326 w-m-full min-h-433 min-h-m-0 h-m-auto ratio-m-87-percent flex-shrink-0"
                        >
                            <img
                                src="${item.image}"
                                alt="best ski image"
                                class="db obj-fit-cover obj-position-left-center pos-absolute top-0 left-0 w-full h-full"
                            />
                        </div>
                        <div
                            class="df fdc gap-24 pt-40 pt-s-32 pl-40 pl-s-16 pr-36 pr-s-16 pb-36 pb-s-20"
                        >
                            <div class="fz-20-24 ff-league-gothic ls-8 tt-u">
                                ${item.title}
                            </div>
                        <div class="df fdc gap-16">
                            ${item.text
                                .map((item) => `<p>${item}</p>`)
                                .join('')}
                        </div>
                        </div>
            </div>`
    );

    const layout = $(`.js-discover-slider-viewport`).append(cards);
    return layout;
}

function createDiscoverCarouselThumbs() {
    const arr = discoverPerformanceData;
    const thumbs = arr.map(
        (item, index) =>
            `<div class="discover-slider-thumbs__button-wrapper">
                    <button
                        type="button"
                        class="discover-slider-thumbs__button ${
                            index === 0 && 'active'
                        }"
                    >
                        <span class="dn di-m">${item.thumbnail[0]}</span
                        ><span class="mobile"
                            ><span class="dn di-m">—</span>${
                                item.thumbnail[1]
                            }</span
                        >
                    </button>
                </div>`
    );

    const layout = $(`.js-discover-slider-thumbs`).append(thumbs);
    return layout;
}

function discoverCarousel() {
    createDiscoverCarouselCards();
    createDiscoverCarouselThumbs();
    setTimeout(() => {
        $(document).trigger('layoutForDiscoverCarouselIsCreated');
    }, 10);
}

runIfElementExist(discoverCarousel, '.js-discover-slider');

function discoverSlider() {
    const slides = document.querySelectorAll('.discover-slider__slide');
    const thumbs = document.querySelectorAll('.discover-slider-thumbs__button');
    let current = 0;
    let isAnimating = false;

    function setViewportHeight() {
        const viewport = document.querySelector('.js-discover-slider-viewport');
        const activeSlide = document.querySelector(
            '.discover-slider__slide.active'
        );
        if (viewport && activeSlide) {
            viewport.style.height = `${activeSlide.offsetHeight + 8}px`;
        }
    }

    setViewportHeight();

    resizeTimer(setViewportHeight, '.js-discover-slider', 300);

    function showSlide(next, direction) {
        if (isAnimating || next === current) return;
        isAnimating = true;

        const outClass =
            direction === 'left' ? 'fade-out-left' : 'fade-out-right';
        const inClass = direction === 'left' ? 'fade-in-right' : 'fade-in-left';

        // Start fade-out on current
        slides[current].classList.remove('active');
        slides[current].classList.add(outClass);

        // Wait for fade-out to finish, then fade-in next
        slides[current].addEventListener('animationend', function handler() {
            slides[current].classList.remove(outClass);
            slides[current].removeEventListener('animationend', handler);

            // Set viewport height to the incoming slide before fade-in
            slides[next].classList.add('active');
            setViewportHeight();
            slides[next].classList.remove('active');

            // Start fade-in on next
            slides[next].classList.add(inClass);

            slides[next].addEventListener('animationend', function handler2() {
                slides[next].classList.remove(inClass);
                slides[next].classList.add('active');
                slides[next].removeEventListener('animationend', handler2);
                current = next;
                thumbs.forEach((btn, idx) => {
                    btn.classList.toggle('active', idx === current);
                });
                isAnimating = false;
            });
        });
    }

    // Thumbs click
    thumbs.forEach((btn, idx) => {
        btn.addEventListener('click', () => {
            if (idx === current) return;
            thumbs.forEach((b, i) => b.classList.toggle('active', i === idx));
            showSlide(idx, idx > current ? 'left' : 'right');
        });
    });

    // Swipe support
    let startX = null;
    let swipeTargetIdx = null;
    const viewport = document.querySelector('.js-discover-slider-viewport');

    viewport.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        swipeTargetIdx = null;
    });

    viewport.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const endX = e.changedTouches[0].clientX;
        const diff = endX - startX;
        if (Math.abs(diff) > 30) {
            if (diff < 0 && current < slides.length - 1) {
                swipeTargetIdx = current + 1;
            } else if (diff > 0 && current > 0) {
                swipeTargetIdx = current - 1;
            }
            if (swipeTargetIdx !== null) {
                thumbs.forEach((b, i) =>
                    b.classList.toggle('active', i === swipeTargetIdx)
                );
                showSlide(
                    swipeTargetIdx,
                    swipeTargetIdx > current ? 'left' : 'right'
                );
            }
        }
        startX = null;
        swipeTargetIdx = null;
    });
}

$(document).on('layoutForDiscoverCarouselIsCreated', function () {
    discoverSlider();
});
